<div [ngStyle]="frameStyle" class="frame">
  <div [ngClass]="{ flash: isFlash }" [ngStyle]="topLeftCornerStyle" class="corner top-left"></div>
  <div [ngClass]="{ flash: isFlash }" [ngStyle]="botLeftCornerStyle" class="corner bot-left"></div>
  <div
    [ngClass]="{ flash: isFlash }"
    [ngStyle]="topRightCornerStyle"
    class="corner top-right"
  ></div>
  <div
    [ngClass]="{ flash: isFlash }"
    [ngStyle]="botRightCornerStyle"
    class="corner bot-right"
  ></div>
  @if (errorMessage) {
    <div class="error-message">
      <span>{{ errorMessage }}</span>
    </div>
  }
</div>
